// Règles d'action sur un RDV qualifié côté agence. Les RDV viennent du partenaire
// (champs `statut`, `slot.start`) ou, en secours, de la table locale (`status`,
// `scheduled_at`) : on accepte les deux formes.

type RdvLike = {
  statut?: string;
  status?: string;
  slot?: { start?: string | null } | null;
  slot_start?: string | null;
  scheduled_at?: string | null;
};

const CANCELLABLE_STATUSES = ['confirmed', 'proposed'];

const rdvStatus = (rdv: RdvLike): string | undefined => rdv.statut ?? rdv.status;

export const rdvStartDate = (rdv: RdvLike): Date | null => {
  const raw = rdv.slot?.start ?? rdv.slot_start ?? rdv.scheduled_at;
  if (!raw) return null;
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
};

// Le partenaire refuse (400) l'annulation d'un créneau écoulé : un RDV passé se
// déclare en no-show. Sans date connue, on laisse le partenaire trancher.
export const canCancelRdv = (rdv: RdvLike, now: Date = new Date()): boolean => {
  const status = rdvStatus(rdv);
  if (!status || !CANCELLABLE_STATUSES.includes(status)) return false;
  const start = rdvStartDate(rdv);
  const isUpcoming = start === null || start.getTime() >= now.getTime();
  return isUpcoming;
};

export const canReportNoShow = (rdv: RdvLike): boolean => rdvStatus(rdv) === 'completed';

// Le backend relaie tel quel le motif du partenaire (champ `message`, même code HTTP).
export const describeRdvActionError = (error: unknown): string => {
  const err = error as { response?: { status?: number; data?: { message?: unknown } } } | null;
  const message = err?.response?.data?.message;
  if (typeof message === 'string' && message.trim()) return message;
  if (err?.response?.status === 400) {
    return "Le partenaire a refusé l'annulation. Si le créneau est déjà passé, déclarez plutôt un no-show.";
  }
  return 'Une erreur est survenue, réessayez.';
};
